import { render, staticRenderFns } from "./MarvelousHolidayBoxProgrammeSignup.vue?vue&type=template&id=bf7a59c0&"
import script from "./MarvelousHolidayBoxProgrammeSignup.vue?vue&type=script&lang=js&"
export * from "./MarvelousHolidayBoxProgrammeSignup.vue?vue&type=script&lang=js&"
import style0 from "./MarvelousHolidayBoxProgrammeSignup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports